import { apiStores } from "../../api/stores";
import { apiGetGeography } from "../../api/apiGetGeography";

export const COUNTRY_REQUEST_START = 'CONTRY_REQUEST_START';
const countryRequestStart = () => ({ type: COUNTRY_REQUEST_START });

export const COUNTRY_REQUEST_ERROR = 'COUNTRY_REQUEST_ERROR';
const countryRequestError = () => ({ type: COUNTRY_REQUEST_ERROR });

export const COUNTRY_REQUEST_SUCCESS = 'COUNTRY_REQUEST_SUCCESS';
const countryRequestSuccess = countries => ({ type: COUNTRY_REQUEST_SUCCESS, countries });


export const countriesGet = () => async (dispatch, getState) => {
    const { settingsReducer } = getState();
    dispatch(countryRequestStart());

    let countries = [];
    try {
        countries = await apiGetGeography(settingsReducer.language);
    } catch (error) {
        dispatch(countryRequestError());
        return false;
    }

    dispatch(countryRequestSuccess(countries));
    return countries;
}


export const STORES_REQUEST_START = 'STORES_REQUEST_START';
const storesRequestStart = () => ({ type: STORES_REQUEST_START });

export const STORES_REQUEST_SUCCESS = 'STORES_REQUEST_SUCCESS';
const storesRequestSuccess = (stores, countryId) => ({ type: STORES_REQUEST_SUCCESS, stores, countryId });

export const STORES_REQUEST_FAIL = 'STORES_REQUEST_FAIL';
const storesRequestFail = () => ({ type: STORES_REQUEST_FAIL });

export const STORES_SELECT_COUNTRY = 'STORES_SELECT_COUNTRY';
export const storesSelectCountry = country => ({ type: STORES_SELECT_COUNTRY, country });

export const storesGetList = country => async (dispatch, getState) => {
    const { storesReducer, settingsReducer } = getState();

    if (!storesReducer.selectedCountry) {
        console.log('No selected country');
        return;
    }
    if (storesReducer.isFetching || storesReducer.stores[country.id]) {
        console.log('Already fetching stores or already having stores for selected country');
        return;
    }

    dispatch(storesRequestStart());

    let stores = [];
    try {
        stores = await apiStores(country.id, settingsReducer.language);
    } catch (error) {
        dispatch(storesRequestFail());
        return false;
    }

    stores = stores.map(store => {
        let translations = {};
        let popupTranslations = null;
        let availabilityTranslations = null;

        let isOpened = false;
        for (let openingTime of store.opening) {
            if (openingTime.timeFrames && openingTime.timeFrames.length !== 0) {
                isOpened = true;
                break;
            }
        }

        if (store.displayProperties && store.displayProperties.resdiary_tnc) {
            translations = store.displayProperties.resdiary_tnc;
            translations = Object.keys(translations).reduce((prev, language) => {
                return { ...prev, [language]: translations[language].replace(/\n/g, "<br />") };
            }, {});
        }

        if (
            store.displayProperties
            && store.displayProperties.dialog_tnc
        ) {
            popupTranslations = {
                primaryTitle: store.displayProperties.dialog_tnc.primary_title,
                primaryMessage: store.displayProperties.dialog_tnc.primary_message,
                primaryButton: store.displayProperties.dialog_tnc.primary_button,
                secondaryTitle: store.displayProperties.dialog_tnc.secondary_title,
                secondaryMessage: store.displayProperties.dialog_tnc.secondary_message,
                secondaryButton: store.displayProperties.dialog_tnc.secondary_button,
            };
        }

        if (
            store.displayProperties
            && store.displayProperties.dialog_availability
            && store.displayProperties.dialog_availability.show
        ) {
            availabilityTranslations = {
                primaryTitle: store.displayProperties.dialog_availability.primary_title,
                primaryMessage: store.displayProperties.dialog_availability.primary_message,
                primaryButton: store.displayProperties.dialog_availability.primary_button,
            }
        }

        return {
            ...store,
            translations,
            popupTranslations,
            availabilityTranslations,
            isOpened,
        };
    });

    dispatch(storesRequestSuccess(stores, country.id));
    return stores;
}


// WEBPACK FOOTER //
// ./src/store/actions/stores.js